import {createContext, useContext} from "react";

const CapabilitiesContext = createContext(null);

export const CapabilitiesProvider = ({value, children}) => (
    <CapabilitiesContext.Provider value={value}>{children}</CapabilitiesContext.Provider>
);

export const useCapabilities = () => {
    const value = useContext(CapabilitiesContext);
    if (!value) throw new Error("useCapabilities must be used within CapabilitiesProvider");
    const actions = new Set(value.actions || []);
    const modules = new Set(value.modules || []);
    return {
        ...value,
        hasAction: (action) => actions.has(action),
        hasAnyModule: (keys) => keys.some((key) => modules.has(key)),
    };
};
